import { Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'

import { PureAsyncSearchInput } from 'src/components/Formik/Forms/PureAsyncSearchInput'

import { formatLabelPerson } from 'src/modules/pessoas/utils'
import { formatLabelEndereco } from 'src/modules/pessoas/utils/labelFormatEndereco'

import { LotesFormData } from '../../types'

interface Props {
  isRestrictedEdit: boolean
}

export const RemetenteFields = ({ isRestrictedEdit }: Props) => {
  const { values } = useFormikContext<LotesFormData>()

  const enderecoRemetenteFilters = useMemo(
    () => ({
      pessoaId: values.remetente?.value
    }),
    [values.remetente?.value]
  )

  return (
    <>
      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="remetente"
          label="Remetente (opcional)"
          url="/pessoas"
          filters={{ ativo: true }}
          labelFormat={formatLabelPerson}
          paramSearch="nomeDocumento"
          disabled={isRestrictedEdit}
          allowSearchWhenDisabled
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="enderecoRemetente"
          label="Endereço Remetente (opcional)"
          url="/enderecos"
          filters={enderecoRemetenteFilters}
          labelFormat={formatLabelEndereco}
          paramSearch="logradouro"
          disabled={!values.remetente?.value || isRestrictedEdit}
          allowSearchWhenDisabled
        />
      </Grid>
    </>
  )
}
